import { GlAvatar, GlIcon, GlIntersperse, GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { compact } from 'lodash-es';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { __ } from '~/locale';
import { NAMESPACE_GROUP, NAMESPACE_PROJECT } from '~/issues/constants';
import usersAutocompleteQuery from '~/graphql_shared/queries/users_autocomplete.query.graphql';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { OPTIONS_NONE_ANY } from '../constants';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
export default {
    name: 'UserToken',
    components: {
        BaseToken,
        GlAvatar,
        GlIcon,
        GlIntersperse,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            // current users visible in list
            users: this.config.initialUsers || [],
            allUsers: this.config.initialUsers || [],
            loading: false
        };
    },
    computed: {
        defaultUsers () {
            return this.config.defaultUsers || OPTIONS_NONE_ANY;
        },
        preloadedUsers () {
            return this.config.preloadedUsers || [];
        },
        namespace () {
            return this.config.isProject ? NAMESPACE_PROJECT : NAMESPACE_GROUP;
        },
        fetchUsersQuery () {
            return this.config.fetchUsers ? this.config.fetchUsers : this.fetchUsersBySearchTerm;
        }
    },
    methods: {
        getActiveUser (users, data) {
            // Case-sensitive matches to default users (generally wildcard values) take
            // priority over case-insensitive matches to all users. Allows `Me` wildcard
            // to be matched before a `me` user.
            if (this.defaultUsers.some(({ value })=>value === data)) return undefined;
            return users.find((user)=>this.getUsername(user).toLowerCase() === data.toLowerCase());
        },
        getAvatarUrl (user) {
            return user?.avatarUrl || user?.avatar_url;
        },
        getUsername (user) {
            return user.username;
        },
        getValueField (user) {
            return user[this.config.valueField] ?? user.username;
        },
        displayNameFor (username) {
            return this.getActiveUser(this.allUsers, username)?.name || username;
        },
        avatarFor (username) {
            const user = this.getActiveUser(this.allUsers, username);
            return this.getAvatarUrl(user);
        },
        fetchUsersBySearchTerm (search) {
            return this.$apollo.query({
                query: usersAutocompleteQuery,
                variables: {
                    fullPath: this.config.fullPath,
                    search,
                    isProject: this.config.isProject
                }
            }).then(({ data })=>data[this.namespace]?.autocompleteUsers);
        },
        fetchUsers (searchTerm) {
            this.loading = true;
            const fetchPromise = this.config.fetchPath ? this.config.fetchUsers(this.config.fetchPath, searchTerm) : this.fetchUsersQuery(searchTerm);
            fetchPromise.then((res)=>{
                // We'd want to avoid doing this check but
                // users.json and /groups/:id/members & /projects/:id/users
                // return response differently
                // TODO: rm when completed https://gitlab.com/gitlab-org/gitlab/-/issues/345756
                this.users = Array.isArray(res) ? compact(res) : compact(res.data);
                this.allUsers = this.allUsers.concat(this.users);
            }).catch(()=>createAlert({
                    message: __('There was a problem fetching users.')
                })).finally(()=>{
                this.loading = false;
            });
        }
    }
};
